import { render, staticRenderFns } from "./WorkIconInitialAssessment.vue?vue&type=template&id=eb4dd51e"
import script from "./WorkIconInitialAssessment.vue?vue&type=script&lang=js"
export * from "./WorkIconInitialAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports